import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c3f2614&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0c3f2614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f2614",
  null
  
)

export default component.exports